"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const throttle_1 = __importDefault(require("lodash/throttle"));
exports.default = (0, vue_1.defineComponent)({
    props: {
        overlapContent: {
            type: Boolean,
            default: true,
        },
    },
    setup(props, ctx) {
        const popupMenuVisible = (0, vue_1.ref)(false);
        const scrolled = (0, vue_1.ref)(false);
        const scrolledDown = (0, vue_1.ref)(false);
        const navClass = (0, vue_1.computed)(() => {
            return [
                // props.overlapContent && !scrolled.value ? 'md:bg-mutedpurple-800' : '',
                // scrolled.value ? 'h-20' : 'lg:h-[7.5rem]',
                // scrolledDown.value ? '-translate-y-full' : 'translate-y-0',
                props.overlapContent ? 'mainnav-overlap' : 'mainnav-no-overlap',
                scrolled.value ? 'mainnav-scrolled' : 'mainnav-unscrolled',
                scrolledDown.value ? 'mainnav-scrolled-down' : 'mainnav-scrolled-up',
                popupMenuVisible.value ? 'mainnav-open' : 'mainnav-closed',
            ];
        });
        let lastScroll = 0;
        const onScroll = (0, throttle_1.default)(() => {
            const currentScroll = window.scrollY;
            scrolled.value = currentScroll > 0;
            if (currentScroll < lastScroll || currentScroll === 0) {
                scrolledDown.value = false;
            }
            else {
                scrolledDown.value = true;
            }
            lastScroll = currentScroll;
        }, 16);
        window.addEventListener('scroll', onScroll, { passive: true });
        function toggleMenu() {
            if (popupMenuVisible.value) {
                const scrollY = document.body.style.top;
                document.body.classList.remove('fixed');
                document.body.style.top = '';
                popupMenuVisible.value = false;
                window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
            }
            else {
                document.body.style.top = `-${window.scrollY}px`;
                document.body.classList.add('fixed');
                popupMenuVisible.value = true;
            }
        }
        onScroll();
        return () => (0, vue_1.h)('div', ctx.slots.default({
            popupMenuVisible: popupMenuVisible.value,
            toggleMenu: toggleMenu,
            navClass: navClass.value,
        }));
    },
});
